import React, { useState, useEffect, useRef } from 'react';
import { useParams, useSearchParams } from "react-router-dom";
import BookingReviewShimmer from '../hotel/BookingReviewShimmer';
import { getProposalURL } from '../../api/axios';
const Printvoucher = () => {
    const { BookingID } = useParams();
    const [loading, setLoading] = useState(true);
    const [iframeHeight, setIframeHeight] = useState('100vh');

    const iframeRef = useRef(null);
    const [searchParams] = useSearchParams();

    const queryString = searchParams.toString();

    const iframeSrc = `${getProposalURL()}/package/print-voucher/${BookingID}?isiframe=true${queryString ? `&${queryString}` : ""
        }`;

    useEffect(() => {
        // Prevent parent Booking page from scrolling
        document.body.style.overflow = 'hidden';

        return () => {
            document.body.style.overflow = '';
        };
    }, []);

    const handleIframeLoad = () => {
        setLoading(false);

        try {
            const iframe = iframeRef.current;

            if (!iframe) return;

            const iframeDocument =
                iframe.contentDocument || iframe.contentWindow.document;

            const height = Math.max(
                iframeDocument.body.scrollHeight,
                iframeDocument.documentElement.scrollHeight
            );

            setIframeHeight(`${height}px`);
        } catch (error) {
            console.log(
                'Unable to calculate height. It may be cross-origin.',
                error
            );
        }
    };

    return (
        <div className="w-full bg-gray-50 overflow-hidden">

            {loading && (
                <div className="max-w-7xl mx-auto">
                    <BookingReviewShimmer />
                </div>
            )}

            <div
                className={`max-w-7xl mx-auto ${loading ? 'hidden' : 'block'
                    }`}
            >
                <iframe
                    ref={iframeRef}
                    src={iframeSrc}
                    title="Print Voucher"
                    onLoad={handleIframeLoad}
                    style={{
                        width: '100%',
                        height: iframeHeight,
                        border: 'none',
                        display: 'block',
                        overflow: 'hidden',
                    }}
                    allow="payment; camera; microphone; geolocation"
                    sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-modals"
                />
            </div>
        </div>
    );
};

export default Printvoucher;